import $ from "jquery"
import { trace } from "rytm-helpers"
import Events from "./Events"
import EventDispatcher from "./EventDispatcher"

/**
* Ajax Swap - ASwap
**/
class ASwap extends EventDispatcher {
  /**
  * ASwap class constructor
  * @constructor
  **/
  constructor() {
    super();
    this.swapSelector = "#stage"; // swap selector
    this.noSwapClassName = "no-as"; // links with this class or target=_blank don't use ajax swap
    this.noCacheClassName = "no-as-cache"; // links with this class don't use ajax cache
    this.htmlAsLoadingClassName = "as-loading";
    this.asAnimationTime = 600; // animation time
    this.useWindowHistory = true; // use push state
    this.noPushStateFallback = true; // fallback of browser dosn't support history push state
    this.refreshOnSameUrl = true; // refresh if same URL is requested
    this.asAnimationTimeout1 = null;
    this.asAnimationTimeout2 = null;
    this.currentUrl = null;
    this.prevUrl = null;
    this.ajaxStore = [];
    this.asHistory = [];
    this.$freshContent = $(this.swapSelector);
  }
  /**
  * trace warning (console.warn)
  * @param obj {Mixed}
  **/
  warning(...obj) {
    console.warn(...obj);
  }
  /**
  * store (cache) the result
  * @param {String} url
  * @param {String} result 
  **/
  storeResult(url, result) { 
    this.ajaxStore.push({url, result});
  }
  /**
  * get the result from cache (if exists)
  * @param {String} url
  * @returns {String|Boolean} stored result / false
  **/
  getStoredResult(url) {
    let result = false;
    this.ajaxStore.forEach( (r, index)=> {      
      if (r.url == url) {        
        result = r.result;
      }
    });
    return result;
  }
  /**
  * parse the result and return content between a tag, eg. <body></body>
  * @param result {String} the ajax request result
  * @param tag {String} the tag name, eg. body
  * @returns {String|Boolean} 
  **/
  getTagFromResult(result, tag) {
    let regex = new RegExp('<' + tag + '[^>]*>((.|[\n\r])*)<\/' + tag + '>');
    let body = regex.exec(result);
    if (body) {
      return body[0];
    } else {
      this.warning("AS problem - " + tag + " could not be extracted");
      return false;
    }
  }

  /**
  * swap the meta and title tags in document's <head>
  * @param result {String} the ajax request result
  **/
  swapHeadMeta(result) {
    let head = this.getTagFromResult(result, "head");
    if (!head) {
      this.warning("AS problem - head was not found in result");
      return false;
    }
    let $head = $(head); 
    $head.each( (index, el)=>{
      // swap only meta and title
      if ($(el).is('title')) {
        document.title = $(el).html();
      }
      if ($(el).is('meta')) {
        let name = $(el).attr("name");
        if (name) {
          $("html head meta[name='" + name + "']").attr("content", $(el).attr("content"));
        }
        let itemprop = $(el).attr("name");
        if (itemprop) {
          $("html head meta[itemprop='" + itemprop + "']").attr("content", $(el).attr("content"));
        }
        let property = $(el).attr("property");
        if (property) {          
          $("html head meta[property='" + property + "']").attr("content", $(el).attr("content"));
        }
      }
    });
  }
  /**
  * swap the HTML class names
  * @param result {String} the ajax request result
  **/
  //
   swapBodyToHtmlClasses(result) {    

    let html = document.createElement('html')
    html.innerHTML = this.getTagFromResult(result, "body")
    let body = html.querySelector('body')
    document.documentElement.className = body.dataset.htmlClasses
  }
  /**
  * get the swap content from ajax request result (select by swapSelector)
  * @param result {String} the ajax request result
  * @returns {jQuery}
  **/
  getFreshContentFromResult(result) {    
    let body = this.getTagFromResult(result, "body");
    if (!body) {
      this.warning("AS problem - body was not found in result");
      return false;
    }    
    let html = document.createElement('html');
    html.innerHTML = body;
    let $resultBody = $(html).find('body'); 
    return $resultBody.find(this.swapSelector);
  }

  /**
  * handle result - animation classes, dispatch events, swap content
  * @param result {String} the ajax request result
  **/
  handleResult(result) {
    // store fresh content in public variable
    this.$freshContent = this.getFreshContentFromResult(result);
    let $swap = $(this.swapSelector);
    // dispatch event
    this.dispatch(Events.NAV_REQUEST_LOADED);        
    $("html").removeClass(this.htmlAsLoadingClassName);
    this.dispatch(Events.NAV_VIEW_HIDE);
    // timeout
    clearTimeout(this.asAnimationTimeout1);
    clearTimeout(this.asAnimationTimeout2);
    this.asAnimationTimeout1 = setTimeout(()=> {
      this.dispatch(Events.NAV_VIEW_HIDDEN);
      this.dispatch(Events.NAV_SWAP_START);
      if (this.$freshContent.length) {
        $swap.attr("class", this.$freshContent.attr("class")); // stage class
        $swap.html(this.$freshContent.html());
      }
      // swap head (meta)
      this.swapHeadMeta(result);
      
      // this.swapBodyToHtmlClasses(result);

      // scroll up
      this.resetScrollPosition();
      // dispatch swap event
      this.dispatch(Events.NAV_SWAP_COMPLETE);
      // animate in
      this.dispatch(Events.NAV_VIEW_SHOW);
      this.asAnimationTimeout2 = setTimeout(()=> { 
        // dispatch event
        this.dispatch(Events.NAV_VIEW_SHOWN);
      }, this.asAnimationTime);        
    }, this.asAnimationTime);
  }
  /**
  * get current URL
  * @returns {String}
  **/
  getCurrentUrl() {
    return this.currentUrl;
  }

  /**
  * extract the last name from path and return it
  * @param {Boolean} includeParams - params divided by "," found always at the end of path
  * @returns {String}
  **/
  getParentPathFromUrl(includeParams = true) {
    let current = window.location.pathname;
    let arr = current.split('/');
    let url = "";
    for (var i = 0; i < arr.length - 1; i++) {
      if (arr[i] && arr[i] != "") {
        url+= "/" + arr[i];
      }
    }
    if (includeParams) {
      let params = current.split(',');      
      for (var i = 1; i < params.length; i++) {
        if (params[i] && params[i] != "") {
          url+= "," + params[i];
        }
      }
    }
    return url;
  }

  /**
  * back - history
  * @param noHistory {Boolean} - if the pushState should be skipped (default false)
  **/
  back(noHistory = false) {
    let url = '/';
    if (this.asHistory.length > 1) {
      url = this.asHistory[this.asHistory.length - 2];
    } else {
      url = this.getParentPathFromUrl();
    }
    this.openURL(url);
  }

  /**
  * scroll back up
  **/
  resetScrollPosition() {
    // $("html, body").animate({ scrollTop: "0" }, 300);
    $("html, body").scrollTop(0);
  }

  /**
  * go to URL
  * @param url {String}
  * @param noHistory {Boolean} - if the pushState should be skipped (default false)
  **/
  openURL(url, noHistory = false, useCache = true) {
    // check if url changed
    if (url == this.getCurrentUrl()) {
      trace("url didn't change", url);
      if (this.refreshOnSameUrl) {
        window.location.href = url;
      }
      return false;
    }
    // dispatch event
    this.dispatch(Events.NAV_REQUEST_URL);
    this.prevUrl = this.currentUrl;
    this.currentUrl = url;
    if (!noHistory) {
      this.pushState(url);
    }
    let result = this.getStoredResult(url);
    if (result) {
      this.handleResult(result);
    } else {
      this.loadURL(url, useCache);
    }
  }
  /**
  * Ajax GET request URL
  * @todo ajax request error handler
  * @param url {String}
  **/
  loadURL(url, useCache = true) {
    // dispatch event
    this.dispatch(Events.NAV_REQUEST_LOAD);
    $("html").addClass(this.htmlAsLoadingClassName);
    trace("ASwap load: ", url);    
    $.get(url, {}, (result)=> {
      if (result) {  
        if (useCache) {
          this.storeResult(url, result);
        }
        this.handleResult(result);
      } else {
        this.warning("AS problem - GET", url, "returned no result");
      }
    });
  }
  /**
  * history pushState (URL)
  * @param url {String}
  **/
  pushState(url) {
    // store url in local history
    this.asHistory.push(url);
    if (!this.useWindowHistory) {
      return false;
    }
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, url);
    }
  }
  /**
  * on history back - open URL (without pushState)
  * @param e {Event}
  **/
  onHistoryBack(e) {
    let url = window.location.pathname + window.location.search;
    this.openURL(url, true);
  }
  /**
  * store / cache the initial URL
  **/  
  storeInitUrl() {
    let url = window.location.pathname + window.location.search;
    let result = document.documentElement.innerHTML;    
    this.storeResult(url, result);
    this.currentUrl = url;
  }
  /**
  * add event listeners
  **/
  addEventListeners() {    
    // catch all a click events
    $("body").on("click", "a", (e)=> {
      let $a = $(e.currentTarget);
      // check black list, target _blank and if ctrl or cmd is not pressed
      if (!$a.hasClass(this.noSwapClassName) && $a.attr("target") != "_blank" && !e.metaKey & !e.ctrlKey) {        
        let useCache = !$a.hasClass(this.noCacheClassName);        
        let url = $a.attr("href");
        if (url.indexOf('://') < 0) {
          e.preventDefault();
          this.openURL(url, false, useCache);
        }
      }
    });
    // window back button support
    $(window).on("popstate", this.onHistoryBack.bind(this));
  }

  initialDispatch() {    
    this.dispatch(Events.NAV_REQUEST_LOADED);        
    // timeout
    clearTimeout(this.asAnimationTimeout1);
    clearTimeout(this.asAnimationTimeout2);
    this.asAnimationTimeout1 = setTimeout(()=> {
      this.dispatch(Events.NAV_SWAP_COMPLETE);      
      this.dispatch(Events.NAV_VIEW_SHOW);
      this.asAnimationTimeout2 = setTimeout(()=> {         
        this.dispatch(Events.NAV_VIEW_SHOWN);
      }, this.asAnimationTime);
    }, this.asAnimationTime);  
  }

  /**
  * init
  **/
  init() {    
    let $swap = $(this.swapSelector);
    if (!$swap.length) {
      this.warning("AS problem - swap container not found!", this.swapSelector);
      return false;
    }
    if (this.noPushStateFallback && (!window.history || !window.history.pushState)) {
      this.warning("AS problem - the browser dosn't support history pushState");
      return false;
    }
    // store init URL
    this.storeInitUrl();
    // initial dispatch (for controllers to do prepare / view)
    this.initialDispatch();
    this.addEventListeners();
  }


}

export default ASwap;